<template>
  <div>
    <i-spin v-if="loading" fix>
      <i-icon type="ios-loading" size="40" class="spin-icon-load" />
    </i-spin>
    <div class="send-bind-card">
      <p class="title">Prepay your send shipping fee</p>
      <div style="margin-top: 20px">
        <i-alert
          show-icon
          style="
            margin-bottom: 0;
            border: none;
            background: #edf9f9;
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
          "
        >
          <template v-slot:desc>
            <p style="color: #66cccc; text-align: start">
              We'll pre-charge the shipping fee for 50 lbs per package. After inbounded, we'll recalculate the fee based
              on actual weight and dimensions, and adjust any difference to your credit card.
            </p>
            <MkLink style="color: #ff9966" @click="showBillProcessDialog = true">About billing process ></MkLink>
            <BillProcessDialog v-model="showBillProcessDialog" :footer-hide="true" />
          </template>
          <template v-slot:icon>
            <i-icon type="ios-alert" color="#66cccc" />
          </template>
        </i-alert>
        <BillPreSendDetail
          :info-prepayment="infoPrepayment"
          :bill-id="billId"
          @update-client-secret="handleUpdateClientSecret"
        />
      </div>
    </div>
    <div class="send-bind-card">
      <p class="title">Add a payment method</p>
      <StripeBindCardPay
        v-if="!loading"
        ref="stripeBindCardPay"
        :bill-type="'prepayment'"
        :bill-id="String(billId)"
        :order-num="orderNum"
        @change-loading="$emit('change-loading', $event)"
        @bind-success="$emit('bind-success')"
        @dom-finished="showPayButton = true"
      />
      <p class="terms">
        By providing your credit card details and agreeing to
        <router-link class="route" to="/">Terms of Pay</router-link>, you authorize us to charge your credit card for
        any future service fees including shipping and storage fees related to this order.
      </p>
      <Button
        v-if="!loading && showPayButton"
        class="confirm"
        style="font-weight: 500"
        @click="$refs.stripeBindCardPay.confirmPayment(isDefault)"
      >
        Pay ${{ infoPrepayment.fee }}
      </Button>
    </div>
  </div>
</template>

<script>
import Button from '../../../components/button/Button';
import { API } from '../../../net/http';
import StripeBindCardPay from '@/components/stripe/StripeBindCardPay.vue';
import BillPreSendDetail from '@/views/bill/components/BillPreSendDetail.vue';
import { googleAdCreateOrder } from '@/utils/googleads';
import MkLink from '@/components/button/MkLink.vue';
import BillProcessDialog from '@/components/home/BillProcessDialog.vue';
export default {
  components: {
    BillProcessDialog,
    MkLink,
    BillPreSendDetail,
    StripeBindCardPay,
    Button,
  },
  data() {
    return {
      loading: true,
      isDefault: false,
      orderNum: this.$route.params.orderNumber,
      billId: '',
      hasDefault: false,
      bindNew: false,
      defaultCardNumber: '',
      infoPrepayment: {},
      showBillBox: false,
      showPayButton: false,
      showBillProcessDialog: false,
    };
  },
  mounted() {
    console.log('prepayment mounted');
    this.fetchPrepaymentInfo();
    document.addEventListener('visibilitychange', this.handleTabVisible);
  },
  methods: {
    handleTabVisible(e) {
      if (e.target.visibilityState === 'visible') {
        this.$post(API.orderExpireTime, { orderNum: this.orderNum }).then(res => {
          if (!res.success) {
            this.$emit('init-countdown', -1);
            return;
          }
          this.infoPrepayment.secondsRemaining = res.data;
          this.$emit('init-countdown', res.data);
        });
      }
    },
    handleUpdateClientSecret(newClientSecret, fee) {
      this.$refs.stripeBindCardPay.updateClientSecret(newClientSecret);
      this.infoPrepayment.fee = fee;
    },
    fetchPrepaymentInfo() {
      this.$post(API.prepaymentInfo, this.orderNum).then(res => {
        if (!res.success) {
          if (res.code === 'kite.common.order.expired') {
            this.showExpiredDialog();
            this.loading = false;
          }
          return;
        }
        const data = res.data;
        googleAdCreateOrder(data.fee);
        // console.log('data', data);
        this.billId = data.billId;
        this.$emit('init-countdown', data.secondsRemaining);
        this.infoPrepayment = data;
        this.loading = false;
      });
    },
    fetchPaymentMethod() {
      this.$post(API.fetchPaymentMethod).then(res => {
        if (!res.success) return;
        const data = res.data;
        this.defaultCardNumber = data.cardNumber;
        if (this.defaultCardNumber) {
          // console.log('hasDefaultCard');
          this.hasDefault = true;
        } else {
          // console.log('noDefaultCard');
          this.hasDefault = false;
        }
        this.loading = false;
      });
    },
    orderUseDefaultCard() {
      this.$post(API.orderUseDefaultCard, this.orderNum).then(res => {
        console.log('bind-success-emit res.success', res.success);
        if (!res.success) return;
        this.$emit('bind-success');
      });
    },
    changeBillBoxShow() {
      this.showBillBox = !this.showBillBox;
    },
    showExpiredDialog() {
      this.$Modal.warning({
        title: 'Unpaid for over 30 minutes!<br />Shipping label canceled! Please place another new order.',
        width: 500,
        onOk: () => {
          this.$emit('change-route', 'sendpackge');
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../../assets/css/main.less';
@import '../../../assets/fonts/font.less';
.send-bind-card {
  .title {
    .font-regular;
    font-size: 14px;
    font-weight: 400;
    color: #262626;
  }
  .terms {
    .font-light;
    margin-top: 26px;
    font-size: 12px;
    font-weight: 300;
    color: @app-black-color;
    .route {
      color: @app-blue-color;
      padding-left: 6px;
    }
  }
  .confirm {
    width: 146px;
    margin: 36px auto 0;
  }
}
.change-button {
  color: @app-blue-color;
}
.card {
  .font-regular;
  background-color: #fbfbfb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 300px;
  height: 66px;
  margin-top: 30px;

  .card-icon {
    width: 40px;
    height: 40px;
    margin: 0 20px;
  }
  .card-title {
    color: #333333;
    font-size: 15px;
  }
  .card-text {
    color: #333333;
    font-size: 12px;
  }
}
.prepay-box {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  .prepay-left {
    display: flex;
    align-items: center;
  }
  .prepay-right {
    display: flex;
    align-items: center;
    text-align: right;
  }
}
.bill-box {
  margin: 20px 40px;
  background: #fbfbfb;
  .bill-item {
    height: 40px;
    margin: 0 20px;
    border-bottom: 1px solid #f2f2f2;
  }
  .bill-item:last-of-type {
    border-bottom: none;
  }
}
</style>
